module.exports = __webpack_public_path__ + "static/media/location-circle.b588d451.svg";